@if (auth.isLoading$ | async) {
  <div>Loading profile...</div>
} @else if ((auth.isAuthenticated$ | async) && (auth.user$ | async); as user) {

    <div class="navbar__username hidden md:block">
      <small class="navbar__username__greeting">Welcome, </small>
      {{ user.name }}
    </div>

    <button
      mat-icon-button
      [matMenuTriggerFor]="accountMenu"
      aria-label="account"
      color="primary"
      class="navbar__account-btn"
    >
      <mat-icon>account_circle</mat-icon>
    </button>
    <mat-menu
      #accountMenu="matMenu"
      MenuPositionX="after"
      [overlapTrigger]="false"
      MenuPositionY="below"
    >
      <button mat-menu-item routerLink="/profile">
        <mat-icon>person</mat-icon>
        <span>My Profile</span>
      </button>

      @if (evService.enableDarkMode) {
        <button mat-menu-item (click)="toggleDarkMode()">
          <mat-icon>dark_mode</mat-icon>
          <span>Toggle Dark Mode</span>
        </button>
      }

      <button mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Log Out</span>
      </button>
    </mat-menu>

}
